import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import dompurify from "isomorphic-dompurify";
import ChevronDown from "@rip/utils/icons/chevron-down.svg";
import "./ProductMultipacks.scss";
const { sanitize } = dompurify;
export const ProductMultiPacksHeader = ({ item }) => {
    if (!item) {
        return _jsx(React.Fragment, {});
    }
    return (_jsxs("button", { className: "product-multipacks__header", children: [_jsx("span", { className: "product-multipacks__header-title", children: item.multiPackName }), item.multiPackDescription && (_jsx("div", { className: "product-multipacks__header-description", dangerouslySetInnerHTML: { __html: sanitize(item.multiPackDescription) } })), _jsx("div", { className: "product-multipacks__header-icon", children: _jsx(ChevronDown, {}) })] }, item.sku));
};
//# sourceMappingURL=ProductMultipacksHeader.js.map